import React from 'react';
import { motion } from 'framer-motion';
import { GraduationCap, ArrowRight } from 'lucide-react';
export function NewsHighlights() {
  return <section className="py-20 bg-white" data-id="element-235">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-236">
        <div className="flex flex-col items-center" data-id="element-237">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-3xl font-bold text-[#800000] font-serif mb-10 text-center" data-id="element-238">
            News & Highlights
          </motion.h2>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="w-full" data-id="element-239">
            <div className="bg-[#FAF9F7] border border-gray-100 rounded-xl p-6 flex items-start gap-4 shadow-sm hover:shadow-md transition-shadow group cursor-pointer" data-id="element-240">
              <div className="bg-[#800000]/10 p-3 rounded-full text-[#800000] shrink-0 mt-1" data-id="element-241">
                <GraduationCap size={24} data-id="element-242" />
              </div>
              <div className="flex-1" data-id="element-243">
                <span className="inline-block px-2 py-1 bg-[#800000]/10 text-[#800000] text-xs font-semibold rounded mb-2" data-id="element-244">
                  Placement
                </span>
                <h3 className="text-lg font-medium text-gray-900 leading-snug group-hover:text-[#800000] transition-colors" data-id="element-245">
                  3 M.Tech students successfully placed in leading organizations
                </h3>
                <p className="text-sm text-gray-500 mt-2" data-id="element-246">
                  Congratulations to our graduating students on their successful
                  placements in top-tier engineering firms.
                </p>
              </div>
              <div className="hidden sm:flex items-center justify-center h-full opacity-0 group-hover:opacity-100 transition-opacity text-[#800000] self-center" data-id="element-247">
                <ArrowRight size={20} data-id="element-248" />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}